// Configuración central del Dentsu Day 2026.
// Todos los datos que cambian entre ediciones viven acá.

// Miércoles 23 de septiembre de 2026, 9:00 hrs (horario de Chile continental).
// Al cambiarla se actualizan countdown, bloque de lugar y textos asociados.
export const EVENT_DATE_ISO = '2026-09-23T09:00:00-03:00';

// Texto visible de la fecha. Debe coincidir con EVENT_DATE_ISO.
export const EVENT_DATE_LABEL = '23 septiembre';

// Formato corto de escaleta, para la linea de pauta del hero.
export const EVENT_DATE_LABEL_CORTO = 'MIÉ 23 SEP 2026';
export const EVENT_TIME_START = '09:00 HRS';

export const EVENT_SCHEDULE = '9:00 - 12:45 hrs';

export const EVENT_VENUE = {
  name: 'Estudio 4, TVN',
  // Sin coma: se usa en mayusculas dentro de la linea de pauta.
  shortName: 'Estudio 4 TVN',
  area: 'Bellavista 0990, Providencia'
};

export const EVENT_NAME = 'dentsu Day 2026';
